import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const navMenuDefaultVariants = {}
const navMenuCompoundVariants = []

const navMenuSlotNames = [
  [
    "root",
    "nav-menu__root"
  ],
  [
    "item",
    "nav-menu__item"
  ]
]
const navMenuSlotFns = /* @__PURE__ */ navMenuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, navMenuDefaultVariants, getSlotCompoundVariant(navMenuCompoundVariants, slotName))])

const navMenuFn = memo((props = {}) => {
  return Object.fromEntries(navMenuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const navMenuVariantKeys = []
const getVariantProps = (variants) => ({ ...navMenuDefaultVariants, ...compact(variants) })

export const navMenu = /* @__PURE__ */ Object.assign(navMenuFn, {
  __recipe__: false,
  __name__: 'navMenu',
  raw: (props) => props,
  variantKeys: navMenuVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, navMenuVariantKeys)
  },
  getVariantProps
})